<template>
  <sui-page>
    <sui-page-header :pageId="contextPageId" />
    <sui-page-contents>
      <div class="comm_scr_wrap">
        <div class="row">
          <div class="col-xs-1">
            <sui-input-label
              :label="$t('MSG_TXT_MDLE')"
              :required="true"
              :vertical="false"
            />
          </div>
          <div class="col-xs-5">
            <sui-module-submodule-select
              ref="selectModule"
              :pageId="contextPageId"
              :selectedMd="searchFrame.selectedCodeValue.moduleCode"
              :selectedSmd="searchFrame.selectedCodeValue.subModuleCode"
              :defaultMdOption="'all'"
              :defaultSmdOption="'all'"
              class="dp_flex"
            />
          </div>
          <div class="btn_wrap">
            <sui-button
              type="button"
              class="comm_btn_Reset "
              @click="onClickReset"
            >
              {{ $t("MSG_BTN_RESET") }}
            </sui-button>
            <sui-button
              v-permission:read="contextPageId"
              type="button"
              class="comm_btn_Scr"
              @click="onClickSearch"
            >
              {{ $t("MSG_BTN_SEARCH") }}
            </sui-button>
          </div>
        </div>
      </div>
      <div class="mrB30" />
      <sui-grid
        ref="mainGrid"
        :columns="gridColumns0"
        :dataset="'dataset0'"
        :showDisplayCountControl="true"
        :initial-pagesize="5"
        @rowselect="onClickGridRow"
      />
      <div class="mrB30" />
      <sui-page-tab-box-type
        ref="tab"
        :tabItems="tabItems"
        :defaultTabIndex="defaultTabIndex"
        :setCurrentTabComponent="setCurrentTabComponent"
        @change-tab-idx="onChangeTabIdx"
      >
        <container
          :is="currentTabComponent"
          :pageId="contextPageId"
          :tableColumnList="tableColumnList"
          :objectId="objectId"
          :objectTypeCode="objectTypeCode"
          @clearGrid="clearGrid"
          @research="onClickSearch"
          @openPopup="openPopup"
          @page-deactivate="handleChildDeactivated"
          @page-activate="handleChildActivated"
        />
      </sui-page-tab-box-type>
    </sui-page-contents>
    <sui-popup
      v-model="isShownPopup"
      :title="$t('MSG_TIT_COL_SELT')"
    >
      <p01
        :pageId="contextPageId"
        :objectId="objectId"
        :objectTypeCode="objectTypeCode"
        :tableColumnList="tableColumnList"
        @closePopup="closePopup"
        @paramReturn="paramReturn"
      />
    </sui-popup>
  </sui-page>
</template>

<script>
import tab01 from './components/PGE_CMU_00016_T01.vue';
import tab02 from './components/PGE_CMU_00016_T02.vue';
import p01 from './components/PGE_CMU_00016_P01';
import BasePage from '~cm/components/BasePage';

const dateTypeFields = ['firstRegistrationDTM', 'finalModificationDTM'];

export default {
  name: 'PGE_CMU_00016', // eslint-disable-line vue/name-property-casing
  components: {
    tab01,
    tab02,
    p01,
  },
  extends: BasePage,
  data() {
    return {
      searchFrame: {
        selectedCodeValue: {
          moduleCode: {
            key: '',
            label: '',
          },
          subModuleCode: {
            key: '',
            label: '',
          },
        },
      },
      objectId: '',
      objectTypeCode: '',
      isShownPopup: false,
      currentTabComponent: 'tab01',
      defaultTabIndex: 0,
    };
  },
  computed: {},
  watch: {},
  datasets: [{
    id: 'dataset0',
    type: 'local',
    data: 'localdata0',
    datafields: [
      { type: 'string', name: 'objectId', map: 'objectId' },
      { type: 'string', name: 'moduleCode', map: 'moduleCode' },
      { type: 'string', name: 'subModuleCode', map: 'subModuleCode' },
      { type: 'string', name: 'objectName', map: 'objectName' },
      { type: 'string', name: 'objectTypeCode', map: 'objectTypeCode' },
      { type: 'string', name: 'objectTypeName', map: 'objectTypeName' },
      { type: 'string', name: 'deleteYn', map: 'deleteYn' },
      { type: 'string', name: 'firstRegistrationDTM', map: 'firstRegistrationDTM' },
      { type: 'string', name: 'firstRegistrationUserId', map: 'firstRegistrationUserId' },
      { type: 'string', name: 'firstRegistrationProgramId', map: 'firstRegistrationProgramId' },
      { type: 'string', name: 'finalModificationDTM', map: 'finalModificationDTM' },
      { type: 'string', name: 'finalModificationUserId', map: 'finalModificationUserId' },
      { type: 'string', name: 'finalModificationProgramId', map: 'finalModificationProgramId' },
      { type: 'string', name: 'moduleName', map: 'moduleName' },
      { type: 'string', name: 'subModuleName', map: 'subModuleName' },
      { type: 'string', name: 'firstRegistrationDisplayLanguageId', map: 'firstRegistrationDisplayLanguageId' },
      { type: 'string', name: 'firstRegistrationLoginId', map: 'firstRegistrationLoginId' },
      { type: 'string', name: 'firstRegistrationKnoxId', map: 'firstRegistrationKnoxId' },
      { type: 'string', name: 'firstRegistrationUserName', map: 'firstRegistrationUserName' },
      { type: 'string', name: 'firstRegistrationUserGlobalName', map: 'firstRegistrationUserGlobalName' },
      { type: 'string', name: 'firstRegistrationDepartmentName', map: 'firstRegistrationDepartmentName' },
      { type: 'string', name: 'firstRegistrationDepartmentEnglishName', map: 'firstRegistrationDepartmentEnglishName' },
      { type: 'string', name: 'finalModificationDisplayLanguageId', map: 'finalModificationDisplayLanguageId' },
      { type: 'string', name: 'finalModificationLoginId', map: 'finalModificationLoginId' },
      { type: 'string', name: 'finalModificationKnoxId', map: 'finalModificationKnoxId' },
      { type: 'string', name: 'finalModificationUserName', map: 'finalModificationUserName' },
      { type: 'string', name: 'finalModificationUserGlobalName', map: 'finalModificationUserGlobalName' },
      { type: 'string', name: 'finalModificationDepartmentName', map: 'finalModificationDepartmentName' },
      { type: 'string', name: 'finalModificationDepartmentEnglishName', map: 'finalModificationDepartmentEnglishName' },
    ],
  }],
  created() {
    this.gridColumns0 = [{
      text: this.$t('MSG_TXT_MDLE'),
      datafield: 'moduleName',
      width: '100px',
    }, {
      text: this.$t('MSG_TXT_SMDLE'),
      datafield: 'subModuleName',
      width: '100px',
    }, {
      text: this.$t('MSG_TXT_OBJ_ID'),
      datafield: 'objectId',
      width: '200px',
    }, {
      text: this.$t('MSG_TXT_OBJ_NM'),
      datafield: 'objectName',
    }, {
      text: this.$t('MSG_TXT_OBJ_TYPE'),
      datafield: 'objectTypeName',
    }, {
      text: this.$t('MSG_TXT_RGST_USR'),
      datafield: 'firstRegistrationUserId',
      createwidget: (row, column, value, htmlElement) => {
        utils.getGridCellFactory().createCellUserName(row, column, value, htmlElement, {
          displayType: '1',
          type: 'link',
          datafieldMap: {
            userId: 'firstRegistrationUserId',
            userName: 'firstRegistrationUserName',
            userGlobalName: 'firstRegistrationUserGlobalName',
            departmentName: 'firstRegistrationDepartmentName',
            departmentEnglishName: 'firstRegistrationDepartmentEnglishName',
            displayLanguageId: 'firstRegistrationDisplayLanguageId',
            loginId: 'firstRegistrationLoginId',
            knoxId: 'firstRegistrationKnoxId',
          },
        }, this.dataset0, this.$refs.mainGrid);
      },
      initwidget(row, column, value, htmlElement) {
        utils.getGridCellFactory().refreshCell(row, column, value, htmlElement);
      },
      width: '200px',
    }, {
      text: this.$t('MSG_TXT_RGST_DTM'),
      datafield: 'firstRegistrationDTM',
      width: '170px',
    }];
    this.tabItems = [
      {
        tabTitle: this.$t('MSG_TXT_OBJ_MGT'),
        tabComponent: tab01,
      },
      {
        tabTitle: this.$t('MSG_TXT_COL'),
        tabComponent: tab02,
      },
    ];
    this.tableColumnList = [];
    this.localdata0 = [];
  },
  mounted() {},
  beforeUpdate() {},
  updated() {},
  beforeDestroy() {},
  destroyed() {},
  methods: {
    setCurrentTabComponent(component) {
      this.currentTabComponent = component;
    },
    onChangeTabIdx(idx) {
      this.currentTabComponent = this.tabItems[idx].tabComponent;
    },
    clearGrid() {
      this.dataset0.clearSelection();
      this.objectId = '';
      this.objectTypeCode = '';
    },
    openPopup() {
      this.isShownPopup = true;
    },
    closePopup() {
      this.isShownPopup = false;
    },
    paramReturn(data, param) {
      this[param] = data;
    },
    onClickReset() {
      this.$refs.selectModule.selectMd('ALL');
    },
    onClickSearch() {
      this.objectId = utils.isEmpty(this.objectId) ? this.objectId : '';

      const queryParams = {
        moduleCode: this.searchFrame.selectedCodeValue.moduleCode.key || '',
        subModuleCode: this.searchFrame.selectedCodeValue.subModuleCode.key || '',
      };
      http.request(this.contextPageId, 'DTS_CMU_00069', {
        query: queryParams,
      }).then(res => {
        utils.dateformatToClientInArray(res.data, dateTypeFields);
        this.dataset0.setRawData(res.data);
      }).catch(error => {
        console.log(error);
      });
    },
    onClickGridRow(dataRow) {
      if (!utils.isEmpty(dataRow.args.row)) {
        const { objectId } = dataRow.args.row;
        this.objectId = objectId;
        this.objectTypeCode = dataRow.args.row.objectTypeCode;
      }
    },
  },
};
</script>

<style scoped>
</style>
